import {
  faExclamationTriangle,
  faQrcode,
  faShareAltSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Alert, Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { QrCodeReader } from "../common/QrCodeReader";
import { ContainerWithHeaderAndMenu } from "../menuandheader/ContainerWithHeaderAndMenu";
import { RoutePaths } from "../RoutePaths";

export function ScanQrCode() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  function handleScan(data?: string) {
    console.debug("ScanQrCodeDialog: Data " + data);
    if (data) {
      if (data.indexOf(RoutePaths.IMPORT_PLAYLIST) > -1) {
        navigate(
          "/" + data.substring(data.indexOf(RoutePaths.IMPORT_PLAYLIST)),
        );
      }
    }
  }

  return (
    <ContainerWithHeaderAndMenu icon={faQrcode} title={t("scanQr.title")}>
      <Row className="g-2">
        <Col md={6} lg={4}>
          <Card>
            <CardHeader>{t("scanQr.importTitle")}</CardHeader>
            <CardBody>
              <QrCodeReader onScanHandler={handleScan} />
            </CardBody>
          </Card>
        </Col>
        <Col>
          <Card>
            <CardHeader>{t("scanQr.instructionTitle")}</CardHeader>
            <CardBody>
              <Alert color="warning" fade={false}>
                <small>
                  <FontAwesomeIcon icon={faExclamationTriangle} />{" "}
                  {t("scanQr.cameraWarning")}
                </small>
              </Alert>
              <h3 className="mb-4">{t("scanQr.title")}</h3>
              <ol className="text-start">
                {t("scanQr.steps", { returnObjects: true }).map((step, i) => (
                  <li key={i} className="mb-2">
                    <Trans
                      components={{
                        icon: (
                          <FontAwesomeIcon
                            icon={faShareAltSquare}
                            className="mx-1"
                          />
                        ),
                        italic: <i />,
                      }}
                    >
                      {step}
                    </Trans>
                  </li>
                ))}
              </ol>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </ContainerWithHeaderAndMenu>
  );
}
